// import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useFilterContext } from "../../context/filterContext";
import AuthLogo from "../assets/iconProfilePicture.png";

function Card(props) {
  const { filter_products } = useFilterContext();

  let reverseArray = [];

  filter_products.forEach((element) => {
    reverseArray.unshift(element);
  });


  return (
    <>
      <section className="text-gray-600 body-font overflow-hidden">
        <div className="container px-5 py-24 mx-auto mt-5">
          <div className=" row d-flex justify-content-center -m-10 px-1 px-md-0">
            {reverseArray.map((item) => {
              return (
                <div
                  key={item._id}
                  className="p-4 p-md-5 p-xl-4 m-xxl-4 mx-lg-4 mx-md-3 my-2 col-xl-5 col-md-5 flex flex-col  bg-secondary bg-opacity-25 rounded"
                >
                  <>
                    <span className=" py-1 ms-auto px-2 rounded bg-indigo-50 text-indigo-500 text-xs font-medium tracking-widest">
                      {item.pitchDate} | {item.pitchTime}
                    </span>
                    <br />
                    <span className="py-1 px-2 me-auto rounded bg-indigo-50 text-indigo-500 text-xs font-medium tracking-widest">
                      {item.pitchType}
                    </span>
                    <h2 className="sm:text-3xl text-2xl title-font font-medium text-white mt-4 mb-4">
                      {item.pitchTitle}
                    </h2>
                    <p
                      className="leading-relaxed mb-8 text-gray-400"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      {item.pitchDescp.slice(0, 250)}.....
                    </p>
                  </>

                  <div className="flex items-center flex-wrap pb-4 mb-4 border-b-2 border-gray-100 mt-auto w-full">
                    <Link
                      to={`/blog/${item._id}`}
                      className="text-indigo-500 inline-flex items-center"
                    >
                      Learn More
                      <svg
                        className="w-4 h-4 ml-2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 12h14" />
                        <path d="M12 5l7 7-7 7" />
                      </svg>
                    </Link>

                  </div>
                  <div className="d-flex items-center">
                    <img
                      alt="blog"
                      src={AuthLogo}
                      className="w-12 h-12 rounded-full flex-shrink-0 object-cover object-center"
                    />
                    <span className="flex-grow flex flex-col pl-4">
                      <span className="title-font font-medium text-white">
                        {item.pitchAuthor}
                      </span>
                      <span className="text-gray-400 text-xs tracking-widest mt-0.5">
                        {item.pitchAuthorCurrentField} |{" "}
                        {item.pitchAuthorNiche}
                      </span>
                    </span>
                    {props.email === item.pitchAuthorEmail ? (
                      <div>
                        <i
                          className="fa-solid fa-pen-to-square text-white fa-xl"
                          data-bs-toggle="modal"
                          data-bs-target="#editModal"
                          onClick={() => {
                            props.setEditId(item._id);
                          }}
                        ></i>
                      </div>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}

export default Card;
